module.exports = __webpack_public_path__ + "static/media/pp_colored_gaint_straw1.647349a4.png";